import { createSessionFetch } from "@project-x/auth";

/**
 * Opaque-session fetch for Consumer protected and cookie-aware API calls.
 * Includes credentials, refreshes once on 401, and notifies the registered
 * session-expired handler when the gateway session cannot be recovered.
 */
export const authFetch = createSessionFetch();
